import { createContext } from "react";
const DataContext = createContext(void 0);
export {
  DataContext as default
};
